import { Link } from "react-router-dom";
import { BASE_URL } from "../apiConfig";
import { useAuth } from "../context/AuthProvider";
import ChangeStatus from "../cors/ChangeStatus";
import ChangeStatusLivreur from "../cors/ChangeStatusLivreur";
import { useState } from "react";
import DeleteModal from "../cors/DeleteModal";
import DuplicateOrders from "../cors/DuplicateOrders";
import StatusHistoryModal from "../cors/StatusHistoryModal";
import { MdOutlineDeliveryDining as Moto } from "react-icons/md";
import { toast } from 'sonner';
import { 
  Truck, 
  Trash2,
  Edit, 
  History, 
  Eye,
  User,
  Headset,
  Settings2,
  MessageSquare,
  CircleAlert,
  Phone,
} from 'lucide-react';
import { FaWhatsapp } from "react-icons/fa";
import { LiaUserSlashSolid } from "react-icons/lia";
import irsaliyat from '../images/irsaliyat.png'
import turboliv from '../images/turboliv.png'
import ozon from '../images/ozon.png'
import tawsilex from '../images/tawsilex.png'
import sift from '../images/sift.ma.png'
import Nexship from '../images/nexship.png'
import Shopify from '../images/Shopify.png'
import Youcan from '../images/youcan.png'
import GoogleSheets from '../images/sheets.png'

import { useLanguage } from "../context/LanguageProvider";

export default function OrderList({ 
  order, 
  formatDateFR, 
  getStatusColor, 
  getStatusText, 
  getStatusIcon,
  fetchOrders,
  page,
  status,
  role,
  selected,
  onSelect,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openChangeStatus, setopenChangeStatus] = useState(false);
  const [openChangeStatusLivreur, setopenChangeStatusLivreur] = useState(false);
  const [openDuplicateOrders, setopenDuplicateOrders] = useState(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const { token, roles } = useAuth();
  const { t, locale } = useLanguage();
  
  const deleteOrder = async () => {
    setIsModalOpen(false); 

    try {
      const res = await fetch(BASE_URL+`/api/orders/${order.id}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })

      if (res.ok) {
        toast.success(t('orders.delete_success'));
        fetchOrders(page);
        
      }
    } catch (error) {
      toast.error(t('orders.delete_failed'));
    }
  }

  const productsTotal = order.products?.reduce(
    (sum, product) => sum + (parseFloat(product.unit_price) * product.quantity),
    0
  );

  const deliveryPrice = parseFloat(order.delivery_price || order.delivery_price || 0);
  const netProfit = parseFloat(order.total) - (deliveryPrice + productsTotal);

  return (
    <>
      <tr key={order.id} className="hover:bg-gray-50 dark:hover:bg-stone-900 transition-colors duration-150">
        {
          ["confirme", "nouveau"].includes(status) && [1, 2].includes(role) ?
            <td className={`${locale === "ar" ? "pr-2" : "pl-2" }`}>
              {
              ["confirme", "nouveau"].includes(order.status) && [1, 2].includes(role) && (
                <div className="inline-flex items-center">
                  <label
                    className="relative flex cursor-pointer items-center rounded-full"
                    data-ripple-dark="true"
                  >
                    <input
                      type="checkbox"
                      checked={selected}
                      onChange={() => onSelect(order.id)}
                      className="before:content[''] peer border-gray-300 relative h-5 w-5 cursor-pointer appearance-none rounded-md border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-teal-500 checked:bg-teal-500 checked:before:bg-teal-500 hover:before:opacity-10"
                    />
                    <div className="pointer-events-none absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 text-white opacity-0 transition-opacity peer-checked:opacity-100">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-3.5 w-3.5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="1"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        ></path>
                      </svg>
                    </div>
                  </label>
                </div>
              )}
            </td>
          :''
        }
        <td className={`${status === "confirme" ? (locale === "ar" ? "pr-2" : "pl-2") : (locale === "ar" ? "pr-6" : "pl-6")} whitespace-nowrap`}>
          <div className="flex items-center gap-8">
            <div>
              <div className="text-xs font-medium text-gray-900">#{order.code}</div>
              <div className="text-[11px] text-gray-500">
                {formatDateFR(order.created_at)}
              </div>
            </div>
            {
              role !== 4 && (
                <div>
                  {order.order_source === 'shopify' && (
                    <div className={`flex items-center justify-center gap-2  ${locale === "ar" ? "max-lg:ml-4" : "max-lg:mr-4"}`}>
                      <img src={Shopify} alt="Shopify" className="w-8 h-8 bg-green-100 rounded-md" />
                      <div className="text-xs font-normal dark:text-white/60">Shopify</div>
                    </div>
                  )}
                  {order.order_source === 'youcan' && (
                    <div className={`flex items-center justify-center gap-2  ${locale === "ar" ? "ml-3" : "mr-3"}`}>
                      <img src={Youcan} alt="Youcan" className="w-8 h-8 bg-purple-100 rounded-md" />
                      <div className="text-xs font-normal text-gray-800 dark:text-white/60">Youcan</div>
                    </div>
                  )}
                  {order.order_source === 'google_sheets' && (
                    <div className={`flex items-center justify-center gap-2  ${locale === "ar" ? "ml-3" : "mr-3"}`}>
                      <img src={GoogleSheets} alt="GoogleSheets" className="w-8 h-8 bg-green-200 rounded-md" />
                      <div className="text-xs font-normal dark:text-white/60">Sheets</div>
                    </div>
                  )}
                </div>
              )
            }
          </div>
        </td>
        
        {
          role !== 4 && (
          <td className="px-2 py-1">
            <div className="max-w-xs">
              {order.seller_info && (
                <div className="flex flex-col gap-1 text-xs max-xl:text-[10px] text-gray-900 truncate">
                  <Link to={`/sallers/${order.seller_info.id}`} className="flex items-center hover:text-blue-600 gap-2">
                    <User className="w-3.5 h-3.5" />{order.seller_info.name_store}
                  </Link>
                  {order.confirmator_name !== null && (
                    <span className="flex items-center gap-2">
                      <Headset className="w-3.5 h-3.5" />{order.confirmator_name || ""}
                    </span>
                  )}
                </div>
              )}
            </div>
          </td>
          )
        }

        <td className="px-2 py-1 cursor-pointer"
          onClick={()=>{ 
            if (role === 1 || role === 2 || role === 3) {
            setopenDuplicateOrders(true)
            }  
          }} >
          {
            order.client != null ?
              <div className="max-w-xs">
                <div className="text-xs font-medium text-gray-900 truncate flex items-center gap-1">
                  { !order.client.black_listed 
                    ?
                    order.client?.name
                    :
                    <span className="bg-stone-800 font-normal rounded-sm flex items-center gap-0.5 py-[1px] px-1 text-[10px] text-white">
                      <LiaUserSlashSolid className="w-3.5 h-3.5"/> 
                      {order.client?.name}
                    </span>
                  }
                  {
                    order.client_other_orders.length > 0 && (role === 1 || role === 2 || role === 3) ?
                      <CircleAlert className="w-3.5 h-3.5 text-orange-600" />
                      :
                      ''
                  }
                </div>
                <div dir='ltr' className={`${locale === "ar" ? "text-right" : ""} text-[11px] text-gray-500`}>+212 {order.client?.phone ?? ""}</div>
                <div className="text-[10px] text-gray-400">
                  {order.client?.city ?? ""},{" "}
                  {(order.client?.address ?? "").length > 15
                    ? (order.client?.address ?? "").slice(0, 15) + "..."
                    : order.client?.address ?? ""}
                </div>
              </div>
              :''
          }
        </td>
        
        <td className="flex items-center gap-1 py-2.5 gap-2 min-w-[180px]">
          <div>
            {order.products?.[0]?.image_py ? (
              <img
                src={`${BASE_URL}/storage/${order.products[0].image_py}`}
                alt={order.products[0].name}
                fill="true"
                className="object-cover h-8 w-8 rounded-md border border-gray-100 group-hover:scale-110"
              />
            ) : (
              <div className="flex items-center justify-center h-full">
                <svg className="h-8 w-8 text-[var(--color-primary-100)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                  />
                </svg>
              </div>
            )}
          </div>
          <div className="flex gap-2">
            {order.products.slice(0, 2).map((product, index) => (
              <div key={index} className="mb-1 last:mb-0 ">
                <div className="flex items-center justify-between">
                  <span className="text-[11px] font-medium text-gray-900 truncate">
                    {(product.name ?? "").length > 20
                      ? (product.name ?? "").slice(0, 20) + "..."
                      : product.name ?? ""
                    }
                  </span>
                  <span className="text-[10px] text-gray-500 ml-2">x{product.quantity}</span>
                </div>
                {product.variants?.length > 0 && (
                  <div className="flex items-center space-x-1 mt-1">
                    {product.variants.slice(0, 2).map((variant, vIndex) => (
                      <div key={vIndex} className="flex items-center space-x-1">
                        {variant.values.slice(0, 1).map((value, valueIndex) => (
                          <div key={valueIndex}>
                            {variant.type === "color" ? (
                              <div className="flex items-center space-x-1">
                                <div
                                  className="w-2.5 h-2.5 rounded-full border border-gray-300"
                                  style={{ backgroundColor: value.value }}
                                />
                                <span className="text-[10px] text-gray-500">{value.name}</span>
                              </div>
                            ) : (
                              <span className="px-1.5 bg-gray-100 text-[11px] rounded text-gray-600">
                                {value.value}
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
            {order.products.length > 2 && (
              <div className="text-xs text-gray-400 mt-1 ">
                +{order.products.length - 2} {t('orders.other_products', { count: order.products.length - 2 })}
              </div>
            )}
          </div>
        </td>

        <td className="px-2 py-1 text-center whitespace-nowrap">
          <div 
            onClick={()=> setIsHistoryModalOpen(true)}
            className="flex cursor-pointer flex-col items-center">
            <span
              className={`inline-flex items-center px-1.5 py-0.5 rounded-full text-[11px] max-xl:text-[10px] font-medium border ${getStatusColor(order.status)}`}
            >
              {getStatusIcon(order.status)}
              {getStatusText(t('status.'+order.status))}
            </span>

            {order.status === "reporte" && (() => {
              const lastReporte = [...order.statusHistorique]
                .filter(s => s.status === "reporte")
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];
              
              return lastReporte?.comment ? (
                <span className="text-[10px] text-white rounded-full px-1 mt-0.5 bg-rose-400">
                  Reporté au : {lastReporte.comment}
                </span>
              ) : null;
            })()}
          </div>
        </td>

        <td className="max-xl:px-1 whitespace-nowrap">
          <div className="text-right">
            <div className="text-sm max-xl:text-xs font-bold text-teal-600">
              {parseFloat(order.total).toLocaleString('fr-FR', { minimumFractionDigits: 2 })} MAD
            </div>
            <div className={`${locale === "ar" ? "" : "justify-end"} text-xs max-xl:text-[11px] text-gray-500 flex items-center`}>
            {
              role == 1 ? (
                order.code_api?.startsWith("CL-IRY-") ? (
                  <img 
                    src={irsaliyat}
                    width={20}
                    height={20}
                    alt="Irsaliyat"
                  />
                ) : order.code_api?.startsWith("OZN-") ? (
                  <img 
                    src={ozon}
                    width={16}
                    height={16}
                    className="mr-1"
                    alt="Ozon"
                  />
                ) : order.code_api?.startsWith("TX-") ? (
                  <img 
                    src={tawsilex}
                    width={20}
                    height={20}
                    className="mr-1"
                    alt="Tawsilex"
                  />
                ) : order.code_api?.startsWith("SIFT-") ? (
                  <img 
                    src={sift}
                    width={24}
                    height={24}
                    className="mr-1"
                    alt="Sift.ma"
                  />
                ) : order.code_api?.startsWith("NEX-") ? (
                  <img 
                    src={Nexship}
                    width={18}
                    height={18}
                    className="mr-1"
                    alt="Nexship"
                  />
                ) : (order.code_api === null || order.code_api?.startsWith("NEXT-")) && order.livreur?.name != null ? (
                  <div className="flex justify-center items-center gap-1 mr-1">
                    <p>{order.livreur?.name}</p>
                    <Moto className="w-3.5 h-3.5 text-gray-500" />
                  </div>
                ) : order.code_api ? (
                  <img 
                    src={turboliv}
                    width={20}
                    height={20}
                    alt="Turboliv"
                  />
                ) : (
                  <Truck className="w-3.5 h-3.5 mr-1" />
                )
              )
               : (
                role !== 4 && ( <Truck className="w-3.5 h-3.5 mr-1" /> )
              )
            }

               { role !== 4 && <span>{deliveryPrice.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} MAD</span> }
            </div>
            {order.change === 1 && (
              <div className="text-[10px] text-orange-600 font-medium">{t('orders.change_label')}</div>
            )}
          </div>
        </td>
        {
          role !== 4 && (
            <td className=" whitespace-nowrap">
              <div className="flex justify-center">
                <div className="text-right">
                  <div className="text-sm max-xl:text-xs font-bold text-green-600">
                    {netProfit.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} MAD
                  </div>
                  <div className="text-[10px] text-gray-500">
                    {t('orders.cost_label')}: {productsTotal.toLocaleString('fr-FR', { minimumFractionDigits: 2 })} MAD
                  </div>
                </div>
              </div>
            </td>
          )
        }

        <td className="py-1 pr-4 whitespace-nowrap text-center text-sm font-medium">
          <div className="flex items-center justify-end gap-2 px-2">
            {openChangeStatus && (
              <ChangeStatus
                fetchOrders={fetchOrders}
                OrderId={order.id}
                OrderCode={order.code}
                setopenChangeStatus={setopenChangeStatus}
              />
            )}
            {openChangeStatusLivreur && (
              <ChangeStatusLivreur
                fetchOrders={fetchOrders}
                OrderId={order.id}
                OrderCode={order.code}
                setopenChangeStatus={setopenChangeStatusLivreur}
              />
            )}
            {((role === 1) || (role === 3)) && (
              order.status === 'nouveau'
              || order.status === 'nonconfirme'
              || order.status === 'reporte'
              || order.status === 'annule'
              || order.status === 'refuse'
            ) ? (
              <button
                onClick={() => setopenChangeStatus((prev) => !prev)}
                className="text-blue-500 cursor-pointer hover:text-blue-700 transition-colors duration-150"
                title={t('orders.change_status_title')}
              >
                <Settings2 className="w-4 h-4" />
              </button>
            ) : null}
            {role === 4 && 
            (
              order.status !== 'livre' &&
              order.status !== 'Livre(paye)' &&
              order.status !== 'paid' &&
              order.status !== 'annule' &&
              order.status !== 'reporte' &&
              order.status !== 'refuse' &&
              order.status !== 'pending_payment' &&
              order.status !== 'retour_recu'
            ) ? (
              <button
                onClick={() => setopenChangeStatusLivreur((prev) => !prev)}
                className="text-blue-500 cursor-pointer hover:text-blue-700 transition-colors duration-150"
                title={t('orders.change_status_title')}
              >
                <Settings2 className="w-4 h-4" />
              </button>
            ) : null}
            
            <>
              {
                order.seller_info &&
                <Link 
                    to={`https://wa.me/212${order.seller_info.phone}`} 
                    target="_blank"
                    className="text-teal-600 hover:text-teal-700 ">
                  <FaWhatsapp className="w-4 h-4" />
                </Link>
              }
              {
                (role === 0 || role === 1 || role === 3) &&
                  <Link 
                    to={`/reclamations?orderId=${ order.id }` }
                    className="text-teal-600 cursor-pointer hover:text-teal-700 transition-colors duration-150"
                    title={t('orders.history_title')}
                  >
                    <MessageSquare className="w-3.5 h-3.5" />
                  </Link>
              }
              <button 
                onClick={()=> setIsHistoryModalOpen(true)}
                className="text-teal-600 cursor-pointer hover:text-teal-700 transition-colors duration-150"
              >
                <History className="w-4 h-4" />
              </button>
                <Link 
                  to={`/orders/update/${order.id}`}
                  className="text-teal-600 cursor-pointer hover:text-teal-700 transition-colors duration-150"
                  title={t('orders.view_title')}
                >
                  <Eye className="w-4 h-4" />
                </Link>
              {
                   (role === 0 && (order.status === 'nouveau' || order.status === 'nonconfirme' || order.status === 'reporte' )) 
                    || (role === 3 && (order.status === 'nouveau' 
                                  || order.status === 'nonconfirme' 
                                  || order.status === 'reporte' 
                                  || order.status === 'confirme' 
                                  || order.status === 'annule' 
                                  || order.status === 'reporte' 
                                  || order.status === 'refuse' ))
                    || (role === 1 )
                    || (role === 2 && roles.update_order === 1 && (
                                     order.status === 'nouveau' 
                                  || order.status === 'nonconfirme' 
                                  || order.status === 'reporte' 
                                  || order.status === 'confirme' 
                                  || order.status === 'annule' 
                                  || order.status === 'reporte' 
                                  || order.status === 'refuse' ))
                 ?
                  <Link 
                    to={`/orders/update/${order.id}`}
                    className="text-teal-600 cursor-pointer hover:text-teal-700 transition-colors duration-150"
                    title={t('orders.edit_title')}
                  >
                    <Edit className="w-4 h-4" />
                  </Link>
                :
                  ''
              }
              {
                order.client && (role == 4 || role == 3) &&
                <Link 
                    to={`tel:${"0" + order.client.phone}`} 
                    className="flex items-center gap-1 border border-gray-300 rounded-lg shadow-sm py-1 px-2 text-stone-700 hover:text-stone-600 hover:bg-gray-100 transition-colors duration-150">
                  <Phone className="w-3.5 h-3.5" />
                  <span className="text-xs">Appler</span>
                </Link>
              }
            </>
              
            {
              role === 1 && status === 'nouveau' ||
              role === 2 && roles.delete_order && status === 'nouveau' ?
              <button 
                onClick={()=>{ setIsModalOpen(true) }}
                className="text-red-500 cursor-pointer hover:text-red-700 transition-colors duration-150"
                title={t('orders.delete_title')}
              >
                <Trash2 className="w-4 h-4" />
              </button>
              :
              ''
            }
          </div>
          {isModalOpen && (
            <DeleteModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              onConfirm={deleteOrder}
              title={t('orders.delete_modal_title')}
              message={t('orders.delete_modal_message')}
              itemName={order.code}
            />
          )}
          {
            isHistoryModalOpen && (
              <StatusHistoryModal
              isOpen={isHistoryModalOpen}
              onClose={() => setIsHistoryModalOpen(false)}
              statusHistorique={order.statusHistorique}
              currentStatus={order.status}
              getStatusColor={getStatusColor}
              getStatusText={getStatusText}
              getStatusIcon={getStatusIcon}
            />
            )
          }
          {
            openDuplicateOrders && (
              <DuplicateOrders
                isOpen={openDuplicateOrders}
                onClose={() => setopenDuplicateOrders(false)}
                HistoryOrders={order.client_other_orders}
                client={order.client}
                fetchOrders={fetchOrders}
                page={page}

            />
            )
          }
        </td>
      </tr>
      
    </>
  );
}



